import { Row, Col, Button, Form, Input, Select, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import * as Icon from "react-feather";
import { useDispatch, useSelector } from 'react-redux';
import userService from '../../services/user-service';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import constantService from '../../services/constant-service';
import StorageUtils from '../../utils/storage-session-utils';
import authenAction from "../../redux/action/authen-action";

const { Option } = Select;

const AddEditUserDialog = ({ isShow, onCancel, onSaveComplete, editData }) => {

    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [userStatus, setUserStatus] = useState([]);
    const [userRole, setUserRole] = useState([]);
    const [loading, setLoading] = useState();
    const [oldUser, setOldUser] = useState();
    const userInfo = useSelector(state => state.authenReducer.userInfo);

    useEffect(() => {
        // console.log(' userInfo ', userInfo);
        async function initData() {
            const { userStatus } = await constantService.getUserStatus();
            setUserStatus(userStatus);

            const { userRole } = await constantService.getUserRole();
            // console.log('userRole ', userRole);
            const screenRoles = userRole.filter((x) => x.value !== 'OTHER');
            setUserRole(screenRoles);
        }

        if (isShow) {
            initData();
        } else if (!isShow) {
            setUserStatus([]);
            setUserRole([]);
        }

    }, [isShow]);

    useEffect(() => {
        if (isShow && editData) {
            setOldUser(editData);
            form.setFieldsValue({
                firstName: editData.profile.firstName,
                lastName: editData.profile.lastName,
                email: editData.profile.email,
                telNo: editData.profile.telNo,
                username: editData.username,
                userPassword: editData.userPassword,
                status: editData.status,
                userRole: editData.userRole
            });
        }
    }, [isShow, editData]);

    const renderUserStatusOptions = () => {
        const result = userStatus.map((item, index) => {
            if (item.value !== 'Z') {
                return (
                    <Option key={index} value={item.value}>
                        {item.labelEn}
                    </Option>
                );
            }
        });
        return result;
    };

    const renderRole = () => {
        const result = userRole.map((item, index) => {
            return (
                <Option key={index} value={item.value}>
                    {item.labelEn}
                </Option>
            );
        });
        return result;
    };

    const onSave = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();

            try {

                dispatch(appLoaderAction.enable());
                let bean = null;
                if (!editData) {

                    if (userInfo.userRole === 'ADMIN' && values.userRole === 'SADMIN') {
                        notifyUtitls.error('คุณไม่สามารถสร้างสิทธิ์ที่สูงกว่า');
                        return;
                    }
                    bean = {
                        username: values.username,
                        userPassword: values.userPassword,
                        userRole: values.userRole,
                        status: values.status,
                        profile: {
                            email: values.email,
                            firstName: values.firstName,
                            lastName: values.lastName,
                            telNo: values.telNo,
                        },
                    };

                    await userService.add(bean);
                } else {
                    if (userInfo.userRole !== 'SADMIN' && editData.userRole === 'SADMIN') {
                        notifyUtitls.error('คุณไม่มีสิทธิ์แก้ไขข้อมูลนี้');
                        return;
                    }
                    bean = JSON.parse(JSON.stringify(editData));

                    bean.userRole = values.userRole;
                    bean.status = values.status;
                    bean.profile.email = values.email;
                    bean.profile.firstName = values.firstName;
                    bean.profile.lastName = values.lastName;
                    bean.profile.telNo = values.telNo;

                    await userService.edit(bean);
                }

                dispatch(appLoaderAction.disale());

                onSaveComplete();
                notifyUtitls.success('สำเร็จ', 'บันทึกสำเร็จ');

                // && oldUser.userRole == 'SADMIN'
                if (editData && oldUser.userRole != bean.userRole && userInfo.username == oldUser.username) {
                    logout();
                }
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
            }
        } catch (errorInfo) {
            notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        StorageUtils.removeToken();
        dispatch(authenAction.signOut());
    }

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title={
                        editData ? 'แก้ไขผู้ใช้งาน' : 'เพิ่มผู้ใช้งาน'
                    }
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSave} loading={loading}>
                            <Icon.Save className="me-2" size={17} />บันทึก
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            ยกเลิก
                        </Button>,
                    ]}>

                    <Form
                        layout="vertical"
                        name="add_edit_user"
                        preserve={false}
                        form={form}>

                        <Row gutter={[30, 5]} >
                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="รหัสผู้ใช้งาน"
                                    name="username"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true
                                        },
                                    ]}>
                                    <Input disabled={editData ? true : false} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="รหัสผ่าน"
                                    name="userPassword"
                                    className="mb-4"
                                    hidden={editData ? true : false}
                                    rules={[
                                        {
                                            required: editData ? false : true
                                        },
                                    ]}>
                                    <Input.Password name="userPassword" className="w-100 h-auto" />
                                </Form.Item>
                            </Col>


                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="ชื่อ"
                                    name="firstName"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="นามสกุล"
                                    name="lastName"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="อีเมล"
                                    name="email"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                            type: 'email',
                                        },
                                    ]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="เบอร์โทรศัพท์"
                                    name="telNo"
                                    className="mb-4"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                        () => ({
                                            /*
                                              NMU-532: an empty field is the
                                              required rule's business, not this
                                              one's. Rejecting empty here too put
                                              both messages under the box at once
                                              — "กรุณาระบุเบอร์โทรศัพท์" followed
                                              immediately by "โปรดระบุตัวเลข
                                              เท่านั้น", which reads as one
                                              garbled sentence.
                                            */
                                            validator(rule, value) {
                                                var numbers = /^[0-9]+$/;

                                                if (!value || value.match(numbers)) {
                                                    return Promise.resolve();
                                                }

                                                return Promise.reject('กรุณาระบุเบอร์โทรศัพท์เป็นตัวเลขเท่านั้น');
                                            },
                                        }),
                                    ]}>
                                    <Input maxLength={10} />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="สิทธิการใช้งาน"
                                    name="userRole"
                                    initialValue=""
                                    // className="mb-0"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}>
                                    <Select>
                                        <Option value="">โปรดระบุ</Option>
                                        {renderRole()}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={8} md={12}>
                                <Form.Item
                                    label="สถานะ"
                                    name="status"
                                    initialValue=""
                                    // className="mb-0"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}>
                                    <Select>
                                        <Option value="">โปรดระบุ</Option>
                                        {renderUserStatusOptions()}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>

                </Modal>
            </div>
        </div>
    );
};

export default AddEditUserDialog;